<template lang="pug">
section#event-page.content-page

    event-page-header(
        v-if="item"
        ref="pageHeader"
        v-bind:item.sync="item"
        v-bind:access-groups="accessGroups"
        v-bind:do-edit="doEdit"
        v-bind:create-mode="createMode")

    div.submenu.navbar(
        v-if="item"
        role="navigation")

        //- Info
        router-link.navbar-item(
            v-bind:class="createMode ? 'disabled router-link-active' : ''"
            v-bind:to="{params: {section: 'info'}}") {{ $t('organization.info') }}

        //- Visitor info
        //- router-link.navbar-item(
        //-     v-bind:class="createMode ? 'disabled' : ''"
        //-     v-bind:to="{params: {section: 'visitor'}}") {{ $t('organization.forVisitor') }}


    div.contents.is-12(
        v-if="item && section.match('info')")

        div.event-info
            //- BodyHtml
            editable-html-section.presentation(
                ref="BodyHtml"
                v-model.lazy="item.BodyHtml"
                v-bind:do-edit="doEdit"
                v-bind:toolbar="false"
                v-bind:editors.lazy="item.Editors")

            //- print-this-page.disabled(v-bind:item="item" v-if="hasInfo && !doEdit")

            //- Videos
            segment(
                v-if="item.VideoPlaylist && !doEdit"
                v-bind:title="$t('videos.title')")
                video-playlist-slides(
                    v-bind:options="videosSlickOptions"
                    v-bind:items="item.VideoPlaylist"
                    v-bind:width="550"
                    v-bind:height="400")

            //- Podcasts
            segment(
                v-if="item.AudioPlaylist && !doEdit"
                v-bind:title="$t('audios.title')")
                audio-playlist(v-bind:items="item.AudioPlaylist")


    div.contents(
        v-if="section.match('visitor') && !createMode && item")
        //- EntryDescriptions: opening hours, ticket prices
        entry-information-entry-description(
            ref="EntryDescription"
            v-bind:entry-description.sync="entryDescription"
            v-bind:parent="item"
            v-bind:show-opening-hours="true"
            v-bind:show-ticket-prices="true"
            v-bind:show-geo-location="true"
            v-bind:do-edit="doEdit"
            v-bind:can-remove="false"
            v-on:change="entryDescription = $event")


    //- Submit (edit)
    submit-button.save(
        v-if="ready && doEdit && !createMode"
        v-on:click="onSave")
        span {{ $t('common.save') }}

    //- Submit (create)
    submit-button.save(
        v-else-if="ready && createMode"
        v-on:click="onPost")
        span {{ $t('articles.release') }}


    //- SubjectItems
    subject-items(
        v-if="ready && item && item.SubjectItems"
        v-bind:subject-items="item.SubjectItems"
        v-bind:show-actors="false"
        v-bind:show-artworks="true"
        v-bind:show-collections="true"
        v-bind:show-events="false"
        v-bind:show-organizations="true")


    //- Children / ChildItems
    div.child-events(
        v-if="childEvents && childEvents.length")
        //- h4.title {{ $t('common.seeAlso') }}
        event-card(
            v-for="(item, index) in childEvents" v-bind:key="index"
            v-bind:item="item"
            v-bind:social="false")

    //- Parent / ParentItem
    div.parent-event(
        v-if="parentEvent")
        event-brochure-stack(
            v-bind:items="[parentEvent]"
            v-bind:count="1")


    //- Artworks (will be deprecated in favor of SubjectItems?)
    segment(
        v-bind:title="$t('common.artworks')"
        v-show="hasArtworks"
        v-if="ready && item && !doEdit")
        div.event-artworks

            div.query-options.columns
                div.column.is-left

                    sort-option.by-actor(
                        v-bind:label="$t('artworks.search.byActor')"
                        v-bind:states="[false, 'ArtistAsc', 'ArtistDesc']"
                        v-on:toggle="setSortOperation"
                        icon="icon-sort-alphabetical")

                    sort-option.by-classification(
                        v-bind:label="$t('artworks.search.byClassification')"
                        v-bind:states="[false, 'ClassificationAsc', 'ClassificationDesc']"
                        v-on:toggle="setSortOperation"
                        icon="icon-sort-alphabetical")

                    sort-option.by-production-time(
                        v-bind:label="$t('artworks.search.byProductionDate')"
                        v-bind:states="[false, 'ProductionTimeLatestDesc,ProductionTimeEarliestDesc', 'ProductionTimeEarliestAsc,ProductionTimeLatestAsc']"
                        v-on:toggle="setSortOperation"
                        icon="icon-sort-numeric")

            //- multi-stack has masonry-tiles, table-view and slideshow
            multi-stack(
                ref="multiStack"
                v-if="ready && !doEdit"
                v-on:loaded="stackCallback"
                v-bind:api="getArtworks"
                v-bind:infinite="false"
                v-bind:resolution="{x: 280}"
                v-bind:toolbar="true"
                v-on:error="error = $event")

    div.somecontent.adjusttocol(v-if="!createMode && item && item.CommunityPinnedPostId && allowCommunity()")
        iframe.somecontent-if(
            v-resize="{   heightCalculationMethod: 'taggedElement' }"
            v-bind:src="getTribeCommunityUrl() + '/embed/post/' + item.CommunityPinnedPostId + '?components=post,responses'"
            frameborder="0"
            allowtransparency="true"
        )
    div.somecontent(v-else-if="!createMode && item && item.CommunityTopicId && allowCommunity()")
        iframe.somecontent-if(
            v-resize="{   heightCalculationMethod: 'taggedElement' }"
            v-bind:src="getTribeCommunityUrl() + '/embed/topic/' + item.CommunityTopicId + '?components=input,feed&feedLimit=5'"
            frameborder="0"
            allowtransparency="true"
        )
    div.somecontent(v-else-if="!isAuthenticated()  && item && (item.CommunityPinnedPostId || item.CommunityTopicId)")
        promotion-no-results-call-to-action.is-parent(
                v-bind:anonymous-only="true")
                template(#bubble-title="")
                    h3.bubble-title {{ $t('social.loginToFindMore') }}

    loading-spinner(v-if="!ready && !error")

    errors-message(v-if="error" v-bind:error="error")

</template>

<script>
import BaseEntityPage from '@/components/Base/EntityPage';
import CommunityMixin from '@/components/Base/CommunityMixin';
export default {
    name: 'event-page',
    extends: BaseEntityPage,

    props: {
        section: {          type: String, default: 'info' },
        parentId: {         type: String },
        contentgroupTags: { type: String }
    },

    mixins: [ CommunityMixin ],

    components: {
        EventPageHeader: () => import('@/components/Event/PageHeader'),
        AudioPlaylist: () => import('@/components/Audio/Playlist'),
        VideoPlaylistSlides: () => import('@/components/Video/PlaylistSlides'),
        EditableHtmlSection: () => import('@/components/EditableHtmlSection'),
        EntryInformationEntryDescription: () => import('@/components/EntryInformation/EntryDescription'),
        // EventBrochureStack: () => import('@/components/Event/BrochureStack'),
        PromotionNoResultsCallToAction: () => import('@/components/global/PromotionNoResultsCallToAction.vue')
    },

    data: function () {
        return {
            resource: 'events',
            pageMetaInfo: {},
            entryDescription: {},
            childEvents: [],
            parentEvent: null,
            hasInfo: false,
            hasArtworks: false
        };
    },

    methods: {
        /**
         * Load view data. Resolves page entity item.
         * BaseEntityPage will set this.item or handle this.error.
         */
        loadViewData: async function (id) {
            return this.getEvent(id);
        },

        getEvent: async function (id, params, config) {

            this.item = null;
            this.error = null;
            this.ready = false;

            this.audios = [];

            this.entryDescription = {};
            this.childEvents = [];
            this.parentEvent = null;
            this.hasInfo = false;
            this.hasArtworks = false;

            // GET event
            await this.$SVC.getEvent(id, params, config)
                .then((response) => {
                    this.item = response.data && response.data.Result;
                })
                .catch(console.error);

            // Event not found
            if (!this.item) {
                return Promise.reject(new Error(this.$t('events.notFound')));
            }

            const item = this.item;

            // check if item has any text data
            this.hasInfo = !!(item.BodyHtml || item.Description);

            // get EntryDescription
            this.entryDescription = item.EntryDescription || {};

            // set default EventClass
            if (!this.item.EventClass) {
                this.item.EventClass = 'OtherEvent';
            }

            // Children / ChildItem
            if (item.ChildItems) {
                this.childEvents = _.filter(item.ChildItems, 'Event');
            }
            else if (item.Children) {
                this.childEvents = item.Children;
            }

            // Parent / ParentItem
            if (item.ParentItem && item.ParentItem.Event) {
                this.parentEvent = item.ParentItem.Event;
            }
            else if (item.Parent) {
                this.parentEvent = item.Parent;
            }

            this.ready = true;
            return Promise.resolve(this.item);
        },

        /**
         * Create new Event. Called from Base/EntityPage.
         */
        initNewEntity: async function () {
            return new Promise((resolve) => {
                this.doEdit = true;
                this.canPublish = true;

                this.entryDescription = {};
                this.item = {
                    Id: '0',
                    Name: '',
                    IngressText: '',
                    EventClass: 'Exhibition',
                    Editors: [
                        this.getCurrentEditor()
                    ]
                };

                resolve(this.item);
                this.ready = true;
                this.$eventBus.$emit('page-ready');
            });
        },
        /**
         * Get event artworks.
         * Multi-stack API function.
         */
        getArtworks: async function (paginationParams, config) {
            const params = _.extend({}, paginationParams, {
                ArtworkSortBy: `[${this.sortOperations.join(',')}]`
            });
            return this.$SVC.getEventArtworks(this.item.Id, params, config);
        },

        /**
         * Callback for multi-stack getArtworks.
         */
        stackCallback: function () {
            // check artwork count only once
            if (!this.hasArtworks && this.$refs.multiStack.getTotalCount() > 0) {
                this.hasArtworks = true;
            }
        },

        /**
         * Select event for updating the resource.
         */
        onSelectEventClass: function (eventClass) {
            if (this.item &&
                ['Exhibition', 'Lecture', 'GuidedTour', 'Music', 'Workshop', 'OtherEvent'].indexOf(eventClass) !== -1
            ) {
                this.item.EventClass = eventClass;
            }
        },

        /**
         * Get custom Event payload.
         */
        getPayload: function () {
            // copy payload fields from the article item
            const payload = _.pick(this.item, this.payloadFields);

            // add ParentId
            if (this.parentId) {
                payload.OrganizerId = this.parentId;
            }

            // add default Editor if missing
            if (!payload.Editors || !payload.Editors.length) {
                payload.Editors = [this.getCurrentEditor()];
            }

            // set Access groups
            _.merge(payload, this.getPayloadAccessGroups(this.accessGroups));

            // add current Locale
            payload.Locale = this.$i18n.locale;

            return payload;
        },

        /**
         * Create new Event.
         */
        onPost: function () {
            const msgSuccess = this.$t('events.createSuccess');
            const msgError = this.$t('events.createError');
            this.busy = true;

            const payload = this.getPayload();
            this.$SVC.postEvent(payload)
                .then((response) => {
                    const id = response && ((response.data && response.data.Id) || response.Id);
                    if (id) {
                        this.$eventBus.$emit('save-success', msgSuccess);

                        // update item with response data (Id and Editors)
                        _.extend(this.item, response.data);

                        this.setCurrentEditValues();

                        // reset SVC cache
                        // this.$SVC.resetCache();

                        // set to private UseProfile, so the route will not lead to 404...
                        this.$store.commit('ux/setUseProfile', 'All');
                        // set edit mode on
                        if (!this.$store.getters['ux/getEditMode']) {
                            this.$store.commit('ux/setEditMode', true);
                        }

                        // update url
                        const route = this.getRoute({Name: this.item.Name, Id: id}, null, 'Event');
                        this.$router.push(route);
                    }
                    else {
                        // const msgError = 'Virhe tallennettaessa artikkelia';
                        this.$eventBus.$emit('save-error', new Error(msgError));
                    }
                })
                .catch((error) => {
                    console.error(error);
                    this.$eventBus.$emit('save-error', error);
                })
                .finally(() => {
                    this.busy = false;
                });
        },

        /**
         * Update method, called from EditableMixin#onSave.
         */
        patchResource: async function () {

            // PATCH Event
            const payload = this.getPayload();
            await this.$SVC.patchEvent(this.item.Id, payload)
                .catch((error) => {
                    this.$eventBus.$emit('save-error', error);
                    this.error = error;
                    // but Event is partially saved, with no rollback
                });

            // Event itself is saved
            this.setCurrentEditValues();

            // save the first EntryDescription
            const entryDescription = this.entryDescription;
            if (entryDescription && Object.keys(entryDescription).length && !entryDescription.EntryDescriptionId) {
                // PUT Event EntryDescription
                await this.$SVC.putEventEntryDescription(this.item.Id, entryDescription)
                    .catch((error) => {
                        this.$eventBus.$emit('save-error', error);
                        this.error = error;
                    });
            }
            else if (entryDescription && entryDescription.EntryDescriptionId) {
                // PATCH Event EntryDescription
                await this.$SVC.patchEventEntryDescription(this.item.Id, entryDescription.EntryDescriptionId, entryDescription)
                    .catch((error) => {
                        this.$eventBus.$emit('save-error', error);
                        this.error = error;
                    });
            }

            this.$eventBus.$emit('save-success');
            // this.$nextTick(this.gotoEvent);
        },
        gotoEvent: function () {
            const route = this.getRoute({Name: this.item.Name, Id: this.item.Id}, null, 'Event');
            this.$router.push(route); // navigate to the new article
        }
    }
};
</script>

<style lang="scss">
// @import '~assets/styles/variables';

#event-page {
    font-size: 1rem;
    .contents {
        display: flex;
        flex-direction: row;
        padding-top: 1rem;
        @media screen and (min-width: $breakpoint-mobile) {
            justify-content: center;
        }
        article {
            display: inline-block;
            //width: 75vw;
            margin: 1rem auto 0.5rem;
            padding: 0 1rem;
            font-size: 1.4rem;
            text-align: left;
            word-break: break-word;
            vertical-align: text-top;
            @media screen and (max-width: $breakpoint-mobile) {
                padding: 0;
            }
        }
        h3 {
            font-family: $helvetica-bold;
            font-size: 18px;
        }
        // stylelint-disable-next-line no-descending-specificity
        p {
            // stylelint-disable-next-line no-descending-specificity
            h1, h2, h3, h4, h5, h6 {
                font-family: inherit;
                font-weight: inherit;
                font-size: inherit;
            }
        }
        .event-info {
            max-width: 67em;
            //margin-right: 4rem;
            section {
                text-align: justify;
            }
            .entry-description {
                padding: 0;
                background: unset;
            }
            @media screen and (min-width: $breakpoint-mobile) {
                margin: 0 4vw;
            }
            @media screen and (min-width: $breakpoint-fullhd) {
                margin: 0 12em;
            }
        }
        .sidebar {
            margin-left: auto;
            padding: 0;
            // stylelint-disable-next-line no-descending-specificity
            section {
                text-align: justify;
            }
            .sidebar-container {
                padding-left: 1rem;
                border-left: 1px solid black;
                @media (max-width: 900px) {
                    padding-left: 0;
                    border-left: 0;
                }
            }
            article {
                width: auto;
            }
            .editr--toolbar {
                overflow: hidden;
            }
            h3 {
                margin-bottom: 0;
            }
            .number-of-works {
                margin-bottom: 1rem;
            }
            .edit-toolbar {
                display: none;
            }
        }
        @media (max-width: 900px) {
            flex-direction: column;
            .column {
                width: 100%;
            }
            .event-info .edit-toolbar {
                display: none;
            }
            // stylelint-disable-next-line no-descending-specificity
            .sidebar .edit-toolbar {
                display: block;
            }
        }
    }
    .event-artworks {
        flex-grow: 0;
        h2.total-count {
            display: block;
            margin: 0 0 2rem;
            font-family: $main-serif;
            font-size: 1.5rem;
        }
        .item {
            margin: 0 10px 10px 0;
            &:last-child {
                margin-right: 0;
            }
        }
        // stylelint-disable-next-line no-descending-specificity
        .card {
            align-self: flex-end;
            .card-header .tile {
                width: 100%;
            }
            // .card-contents {
            //     .owner, .event {
            //         display: none;
            //     }
            // }
            figure {
                margin: 0;
            }
        }
        // .artwork-sidebar {
        //     .details .event {
        //         display: none;
        //     }
        // }

        .stacking-modes-toolbar {
            @media (min-width: 950px) {
                margin-top: -4rem;
            }
        }
    }
    .submit-button.save {
        display: block;
    }

    .subject-items {
        .subject-artworks {
            order: 1;
        }
        .subject-organizations {
            order: 2;
        }
        .subject-collections {
            order: 2;
        }
    }
    .adjusttocol {
        max-width: 67em;
        margin-right: auto;
        margin-left: auto;
    }
    // .somecontent {
    // }
    .somecontent-if {
        width: 100%;
    }
}
</style>
